'use strict';
import { BaseService } from '@narrate/base-sdk';


/**
 * uses api to store and retrieve the user report
 *
 * future work:
 *  may handle conflict resolution
 *
 * @example
 *    // using CoreService (recommended)
 *    import Core from '@narrate/core-sdk';
 *
 *    const { value: report } = await Core.api.report.get();
 *    console.log(report); // should be something like { birthdate: }
 *
 *    await Core.api.report.save({ videos: [] });
 */
class ReportService extends BaseService {

  constructor() {
    super({ configPath: 'services.report' });
  }

  async find(id) {
    return await this.requestResource('get', {
      params: {
        id
      }
    });
  }

  async create(report) {
    return await this.requestResource('create', {
      method: 'post',
      data: report,
    });
  }

  async reportConversation(message, initialUserId, participantUserId, messageNumber) {
    return await this.create({
      type: 'Conversation',
      message,
      initialUserId,
      participantUserId,
      messageNumber,
    });
  }

  async reportAccessBlock(message, accessBlockId) {
    return await this.create({
      type: 'AccessBlock',
      message,
      accessBlockId,
    });
  }

  async reportUser(message, reportedUserId) {
    return await this.create({
      type: 'User',
      message,
      reportedUserId,
    });
  }

  async requestPayment(message, reportedUserId) {
    return await this.create({
      type: 'Payment',
      message,
    });
  }

  async reportAppIssue(message) {
    return await this.create({
      type: 'App',
      message,
    });
  }

  async list() {
    const { Items, ...rest } = await this.requestRootResource();

    return {
      ...rest,
      Items
    };

  }
}

export default ReportService;
